// import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      name: '',
      permises: {   // USE!!
        settingGroups: true
      }
      // pictures: [],
    }
  },

  forSimple(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    }
  },

  forClub(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category
    }
  },

  forPlayer(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    }
  },

  forCreate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures)
    };
  },

  forUpdate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures)
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-model.js